﻿/**
 * Ileara editorial reveal — fluid rise/fade (text) + settle (hero media).
 * Respects prefers-reduced-motion; no-JS fallback leaves content visible.
 */
(() => {
  const root = document.documentElement;

  // Stands down the theme.liquid failsafe that would otherwise disarm the reveal.
  root.setAttribute('data-ileara-reveal-ready', '');

  const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const STAGGER = { display: 64, ui: 64 };
  const HERO_TEXT_LEAD = 100;

  const prefersReduced = () => mqReduce.matches;

  // Without the armed class the hidden state never applies, so animating would
  // only cause a flash — reveal in place instead.
  const isArmed = () => root.classList.contains('ileara-reveal-armed');

  const revealGroup = (group) => {
    group.classList.add('is-inview');
  };

  const assignDelays = (group) => {
    const lead = group.hasAttribute('data-reveal-immediate') ? HERO_TEXT_LEAD : 0;

    group.querySelectorAll('[data-reveal="media"]').forEach((el) => {
      el.style.setProperty('--reveal-delay', '0ms');
    });

    let delay = lead;
    group.querySelectorAll('[data-reveal="display"], [data-reveal="ui"]').forEach((el) => {
      el.style.setProperty('--reveal-delay', `${delay}ms`);
      const tier = el.getAttribute('data-reveal');
      delay += STAGGER[tier] || STAGGER.ui;
    });
  };

  const initGroup = (group) => {
    if (group.hasAttribute('data-reveal-init')) return;
    group.setAttribute('data-reveal-init', '');

    if (!isArmed() || prefersReduced() || !('IntersectionObserver' in window)) {
      revealGroup(group);
      return;
    }

    assignDelays(group);

    if (group.hasAttribute('data-reveal-immediate')) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          void group.offsetHeight;
          revealGroup(group);
        });
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealGroup(group);
          observer.unobserve(group);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(group);
  };

  const init = () => {
    document.querySelectorAll('.ileara-reveal[data-reveal-group]').forEach(initGroup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  mqReduce.addEventListener('change', () => {
    if (!prefersReduced()) return;
    document.querySelectorAll('.ileara-reveal[data-reveal-group]').forEach(revealGroup);
  });
})();
